const MIN_DATE = new Date('1900/01/01');

const MAX_DATE = new Date();

export { MIN_DATE, MAX_DATE };
